import React from "react";
import Spinner from "components/Spinner";
import { useSelector } from "react-redux";

function WithLoading(props) {
  const { checkoutLoader } = useSelector((state) => state.loader);

  if (props?.loading || checkoutLoader)
    return (
      <div className="fixed z-50 max-460 min-h-app-height overflow-hidden w-full h-full back-filter">
        <Spinner />
      </div>
    );
  return null;
}

export const WithTransparentSpinner = ({loading}) => {
  if (loading)
    return (
      <div className="w-full h-full fixed top-0 left-0 right-0 flex justify-center items-center" style={{ zIndex: 500 }}>
        <div className="max-460 bg-gray-500 bg-opacity-50 h-full w-full flex justify-center items-center">
          <Spinner />
        </div>
      </div>
    );
  return null;
}



export default WithLoading;
